import React from 'react';
import Media from 'react-media';
import { SCREEN } from 'scenes/common/types/screen';
import { MotorFunnelState } from 'scenes/motor/types';
import { progressGroup } from '../helpers/progress';
import { DesktopProgressBar } from './desktop/DesktopProgressBar';
import { NumberedProgressBar as MobileProgressBar } from './mobile/NumberedProgressBar';

interface MotorProgressBarProps {
  funnelState: MotorFunnelState;
}

export const MotorProgressBar = ({ funnelState }: MotorProgressBarProps) => (
  <Media query={{ minWidth: SCREEN.LARGE }}>
    {(isLargeScreen) => {
      if (isLargeScreen) {
        return (
          <DesktopProgressBar flow={funnelState.flow} step={funnelState.step} />
        );
      }
      return <MobileProgressBar flowProgress={progressGroup(funnelState)} />;
    }}
  </Media>
);
